/** A cancelled report must not leave a profile retry scheduled. */
export const queryStatsDelay = (delayMs: number, signal?: AbortSignal): Promise<boolean> => {
  if (signal?.aborted) return Promise.resolve(false);
  return new Promise((resolve) => {
    const finish = (elapsed: boolean): void => {
      clearTimeout(timer);
      signal?.removeEventListener('abort', abort);
      resolve(elapsed);
    };
    const abort = (): void => finish(false);
    const timer = setTimeout(() => finish(true), delayMs);
    signal?.addEventListener('abort', abort, { once: true });
  });
};
